import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { PaginatedWorkshops } from '../api/types';
import config from '../config';

//TODO check if this is still needed and if so where => replace it
export enum WorkshopStatus {
  ACTIVE = '300',
}
async function getWorkshops(props: {
  axios: AxiosInstance;
  searchString?: string;
  page?: number;
  itemsPerPage?: number;
  status?: Array<string>;
  country?: string;
  isVerified?: boolean;
  systemPartner?: number;
  whitelabelOrganizationId?: number;
}): Promise<PaginatedWorkshops> {
  const { axios, searchString, page, itemsPerPage, status = [], country, isVerified, systemPartner, whitelabelOrganizationId } = props;
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/workshop`, {
    params: {
      searchString: searchString || '',
      page,
      itemsPerPage,
      status: status.length > 0 ? status?.join() : undefined,
      whitelabelOrganizationId,
      country,
      verified: isVerified,
      systempartner: systemPartner,
    },
  });
  return data;
}

export default function useWorkshopsQuery({
  searchString,
  page,
  itemsPerPage,
  whitelabelOrganizationId,
  status,
  country,
  isVerified,
  systemPartner,
}: {
  searchString?: string;
  page?: number;
  itemsPerPage?: number;
  whitelabelOrganizationId?: number;
  status?: Array<string>;
  country?: string;
  isVerified?: boolean;
  systemPartner?: number;
}) {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey({
      searchString,
      page,
      itemsPerPage,
      status,
      whitelabelOrganizationId,
      country,
      isVerified,
      systemPartner,
    }),
    queryFn: () =>
      getWorkshops({
        axios,
        searchString,
        page,
        itemsPerPage,
        status,
        whitelabelOrganizationId,
        country,
        isVerified,
        systemPartner,
      }),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
    refetchOnMount: 'always',
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, query.error as any);
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey({
  searchString,
  page,
  itemsPerPage,
  status,
  whitelabelOrganizationId,
  country,
  isVerified,
  systemPartner,
}: {
  searchString?: string;
  page?: number;
  itemsPerPage?: number;
  status?: Array<string>;
  whitelabelOrganizationId?: number;
  country?: string;
  isVerified?: boolean;
  systemPartner?: number;
}) {
  return [
    'Workshops',
    searchString,
    page,
    itemsPerPage,
    status,
    whitelabelOrganizationId,
    country,
    isVerified,
    systemPartner,
  ] as const satisfies QueryKey;
}
useWorkshopsQuery.getKey = getKey;
